import DashboardButton, { DashboardButtonProps } from './DashboardButton';

export type { DashboardButtonProps };
export default DashboardButton;
